import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions'

@Component({
  selector: 'app-camera-scanner',
  templateUrl: './camera-scanner.component.html',
  styleUrls: ['./camera-scanner.component.scss']
})
export class CameraScannerComponent implements OnInit {

  constructor(
    private store$: Store
  ) { 
  
  }

  ngOnInit(): void {
  }

  public onCodeResult(event){

  }

}
